module.exports = __webpack_public_path__ + "static/media/tiendaVerde.b50cf1e9.png";